import React, { Component } from "react";
import { Container } from "reactstrap";
// import { Divider, Input, Empty } from "antd";
import ChoiceSystem from "./choiceSystem";
// import ListSystem from "./listSystem";
// import ListSystem from "./listSystem";

const FactSystemPage = ({plant_id}) => {

    return (
      <Container className="animated fadeIn">
        <ChoiceSystem plant_id={plant_id}/>
        
      </Container>
    );
  
}

export default FactSystemPage;
